import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Http, Response, URLSearchParams, Headers, RequestOptions } from '@angular/http';
import 'rxjs';

import { Config } from "../../config";
import { Subject } from "rxjs";
import { HttpService } from "../shared/services/http.interceptor.service";
import { UserInfoService, GetToken } from "../shared/services/security.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { SharedService } from "../shared/services/shared.service";
import { NotificationsService } from "angular2-notifications";
import * as moment from 'moment-timezone';
import { ActivatedRoute, Router } from "@angular/router";
import { of } from "rxjs/observable/of";
import { map } from "rxjs/operators";

@Injectable()
export class AppointmentsService {
    public options: any;
    disableOutlookLink = new Subject<any>();
    enableOutlookLink = new Subject<any>();
    httpOptions;
    OffsetValue;
    isExternal;
    config:any

    public officeId = null;
    setOffice(officeId) {
        this.officeId = officeId;
        if(!this.isExternal){
            localStorage.setItem('officeId', officeId);
        }
    }
    getOffice() {
        if(!this.isExternal){
            this.officeId = localStorage.getItem('officeId');
        }
        return this.officeId;
    }

    public officeSubject = new Subject<any>();

    officeChange(data: any) {
        this.officeSubject.next(data);
    }

    isofficeChange() {
        return this.officeSubject.asObservable();
    }

    public userSubject = new Subject<any>();

    userChange(data: any) {
        this.userSubject.next(data);
    }

    isuserChange() {
        return this.userSubject.asObservable();
    }

    public currentLanguage = new BehaviorSubject<any>(null);
    setLanguage(lang) {
        this.currentLanguage.next(lang)
    }
    getLanguage() {
        return this.currentLanguage.asObservable();
    }

    public isCalendarValidForConference = new BehaviorSubject<boolean>(false);
    setCalendarConferenceValidity(isValid:boolean) {
        this.isCalendarValidForConference.next(isValid)
    }
    getCalendarConferenceValidity() {
        return this.isCalendarValidForConference.asObservable();
    }

    public inValidAppointments = new BehaviorSubject<any>(null);
    setInValidAppointments(obj:any) {
        this.inValidAppointments.next(obj)
    }
    getInValidAppointments() {
        return this.inValidAppointments.asObservable();
    }


    language = new Subject();
    constructor(private http: HttpClient,
        private userInfoService: UserInfoService,
        private sharedService: SharedService,
        private notificationsService: NotificationsService,
        private HTTP: HttpService,
        private router: Router,
        private route : ActivatedRoute) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        this.options = new RequestOptions({ headers: headers });
        // this.OffsetValue = this.userInfoService.get().OffsetValue

        let localTimeZone: string = moment.tz.guess();
        let m = moment().tz(localTimeZone)
        this.OffsetValue = m._offset * 60 * 1000 * -1;
        this.isExternal = this.route.snapshot.queryParams["isExternal"];
        this.config = new Config();
    }

    /**
     * 
     * @param officeId : Fectch data according to the id
     */
    getAppointmentListOfficeId(officeId, companyWise): Observable<any> {

        return this.HTTP.get('Appointment/GetAppointmentTypeList?OfficeId=' + officeId + '&CompanyWise=' + companyWise + '&IsHitfromAppointmentModule=' + true)
            .map((response) => {
                return response.json().data;
            })
    }

    /**
     * Function to Add appointment types
     * @param body : Body 
     */
    addAppointmentType(body): Observable<any> {
        //console.log(JSON.stringify(body))

        return this.HTTP.post('Appointment/AddAppointmentType', body)
            .map((response) => {
                return response.json().data;
            })
    }

    private appointmentTypesDetailSubject = new Subject<any>();

    setTypesDetail(types: any) {
        this.appointmentTypesDetailSubject.next(types);
    }

    getTypesDetail() {
        return this.appointmentTypesDetailSubject.asObservable();
    }
    /**
     * Update Appointment Types
     */
    updateAppointmentTypes(body): Observable<any> {
        //console.log(JSON.stringify(body))
        return this.HTTP.post('Appointment/EditAppointmentType', body)
            .map((response) => {
                return response.json().data;
            })
    }

    getSuggestion(body): Observable<any> {
        return this.HTTP.post(`Appointment/GetSuggestions`, body)
            .map((response) => {
                return response.json().data;
            })
    }

    /**
     * Add Category
     * @param body 
     */
    addCategory(body): Observable<any> {
        return this.HTTP.post('Category/AddCategory', body)
            .map((response) => {
                return response.json().data
            })
    }

    /**
     * Get Categories
     */
    getCategory(): Observable<any> {
        return this.HTTP.get('Category/GetCategoryList')
            .map((response) => {
                return response.json().data
            })
    }

    getTag(): Observable<any> {
        let config = new Config();
        let companyCode = this.getCookie('clientCode');
        return this.HTTP.get(config.accountApiUrl + 'v1/integration/tags?clientCode=' + companyCode + '&moduleName=' + 'Appointment')
            .map((response) => {
                return response.json();
            })
    }

    /**
     * Get appointment type detail
     */
    getAppointmentTypeDetail(id): Observable<any> {
        return this.HTTP.get('Appointment/GetAppointmentTypeDetails?Id=' + id)
            .map((response) => {
                return response.json().data;
            })
    }

    /**
     * DELETE appointment types
     */
    deleteAppointmentType(type_id): Observable<any> {
        var requestOption = new RequestOptions({
            body: { id: type_id }
        })
        return this.HTTP.delete('Appointment/DeleteAppointmentType', requestOption)
            .map((response) => {
                return response.json().data;
            })
    }

    getToken(data, rlocation) {
        let token = this.getCookie('token');
        let companyCode = this.getCookie('clientCode');
        this.HTTP.get("Integration/GetToken?Code=" + data + "&RedirectionURL=" + rlocation, this.httpOptions).subscribe(response => {
            this.disableOutlookLink.next(true);
            this.userInfoService._info.IsConnected = true
        });
    }

    getToken2(code, rlocation): Observable<any> {
        return this.HTTP.get("Integration/GetToken?Code=" + code + "&RedirectionURL=" + rlocation, this.httpOptions)
            .map((response) => {
                return response.json();
            })
    }

    // POST /api/v1/User/GetUserListByOfficeIds

    getUserListByOfficeIds(body) {
        let token = this.getCookie('token');
        let companyCode = this.getCookie('clientCode');
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('JwtToken', token);
        headers.append('CompanyCode', companyCode)
        this.options = new RequestOptions({ headers: headers });
        return this.HTTP.post("User/GetUserListByOfficeIds", body, this.options).map((response) => {
            return response.json().data;
        });
    }

    disableOutlook(type) {
        let token = this.getCookie('token');
        let companyCode = this.getCookie('clientCode');
        this.HTTP.get("Integration/DisableCalendarIntegration?Type=" + type).subscribe(response => {
            this.enableOutlookLink.next(true);
            this.userInfoService._info.IsConnected = false
            this.sharedService.getTranslatedNotification(27);
        }, (error) => {
            this.notificationsService.error(error);
            console.log(error)
        });
    }

    getCalenderList(data) {
        return this.HTTP.post("Integration/GetExternalCalendarList?Type=" + data, {}, this.httpOptions).map(response => {
            return response.json().data;
        });
    }


    /**
     * APPOINTMENT CALENDER API CALLS. 
     * NOTE: PLS WRITE APPOINTMENT CALENDER API CALLS BELOW
     */

    /**
     * Get appointment calender scheduling data
     */
    getSchedulingLimits(officeId): Observable<any> {
        return this.HTTP.get('Appointment/GetSchedulingLimits?OfficeId=' + officeId)
            .map((response) => {
                return response.json().data;
            })
    }

    /**
     * Update appointment calender scheduling data
     */
    updateSchedulingLimits(body): Observable<any> {
        return this.HTTP.post('Appointment/UpdateSchedulingLimits', body)
            .map((response) => {
                return response.json().data
            })
    }

    /**
     * Add Appointment Calendar
     */
    addAppointmentCalendar(body): Observable<any> {
        return this.HTTP.post('Appointment/AddCalendar', body)
            .map((response) => {
                return response.json().data;
            })
    }


    /**
     * Get Calendar list
     */
    getCalendarList(buisnessUserId, officeId?, IsIncludeInactiveCalendar?, timeZone: string = "", isShortCalenderDetails?): Observable<any> {
        if (IsIncludeInactiveCalendar) {
            return this.HTTP.get('Appointment/GetCalendarList?BusinessUserId=' + buisnessUserId + '&OfficeId=' + officeId + '&IsIncludeInactiveCalendar=' + true + '&SelectedTimeZone=' + timeZone + '&isShortCalenderDetails='+ isShortCalenderDetails)
                .map((response) => {
                    return response.json().data;
                })
        } else {
            return this.HTTP.get('Appointment/GetCalendarList?BusinessUserId=' + buisnessUserId + '&OfficeId=' + officeId + '&SelectedTimeZone=' + timeZone)
                .map((response) => {
                    return response.json().data;
                })
        }
    }

    getCalendarListData(buisnessUserId, officeId?, IsIncludeInactiveCalendar?, timeZone: string = "", isShortCalenderDetails?) {
        if (IsIncludeInactiveCalendar) {
            return this.HTTP.post('Appointment/GetCalendarListData?BusinessUserId='+ buisnessUserId +'&IsIncludeInactiveCalendar=' + true + '&SelectedTimeZone=' + timeZone + '&isShortCalenderDetails='+ isShortCalenderDetails, officeId)
                .map((response) => {
                    return response.json().data;
                })
        }else{
            return this.HTTP.post('Appointment/GetCalendarListData?BusinessUserId='+ buisnessUserId + '&SelectedTimeZone=' + timeZone, officeId)
            .map((response) => {
                return response.json().data;
            })
        }
    }

    getCalendarListWithPagination(body) {
        // body['isHitfromAppointmentModule'] = true
        return this.HTTP.post('Appointment/GetCalendarListWithPagination', body)
            .map((response) => {
                return response.json().data;
            })
    }

    getAppointmentTypeListWithPagination(body) {
        return this.HTTP.post('Appointment/GetAppointmentTypeListWithPagination', body)
            .map((response) => {
                return response.json().data;
            })
    }


    /**
     * Add BlockOff Calendar
     */
    addBlockOffCalendar(body): Observable<any> {
        return this.HTTP.post('Appointment/AddBlockOffCalendar', body)
            .map((response) => {
                return response.json().data;
            })
    }

    /**
     * Get appointment calendar detail
     */
    getCalendarDetailbyId(id): Observable<any> {
        return this.HTTP.get('Appointment/GetCalendarDetails?id=' + id + '&OffsetValue=' + this.OffsetValue)
            .map((response) => {
                return response.json().data
            })
    }


    /**
     * Update Calendar Detail
     */
    updateCalendarDetail(body): Observable<any> {
        return this.HTTP.post('Appointment/EditCalendar', body)
            .map((response) => {
                return response.json().data;
            })
    }

    /**
     * Function to delete calendar
     */
    deleteCalendar(id): Observable<any> {
        var requestOption = new RequestOptions({
            body: { id: id }
        })
        return this.HTTP.delete('Appointment/DeleteCalendar', requestOption)
            .map((response) => {
                return response.json().data
            })
    }



    /**
     * TEAM-APPOINTMENT-CALENDAR API CALLS
     */

    /**
     * Get the list of the users according to officeId
     */
    getUsersListWithOfficeId(officeid): Observable<any> {
        return this.HTTP.get('User/GetUserListByOfficeId?OfficeId=' + officeid)
            .map((response) => {
                return response.json().data
            })
    }


    /**
     * Email and Sms Template api calls
     */
    addTemplate(body): Observable<any> {
        return this.HTTP.post('NotificationTemplate/AddAppointmentTypeToTemplate', body)
            .map((response) => {
                return response.json().data;
            })
    }

    /**
     * Function to return the list of templates in a given notificatin type
     * @param notification_type: e.g {
                                       INITIAL = 1,
                                       CONFIRMATION = 2,
                                       REMINDER = 3,
                                       RESCHEDULING = 4,
                                       CANCELLATION = 5
                                      }
     * @param officeId : CurrentOffice Id selected
     */
    getNotificationTemplate(notification_type, officeId): Observable<any> {
        return this.HTTP.get('NotificationTemplate/GetTemplateTypeDetails?NotificationType=' + notification_type + '&OfficeId=' + officeId)
            .map((response) => {
                return response.json().data;
            })
    }


    /**
     * Update Template Appointment type when dragged
     */
    updateAppointmentTypeTemplate(body): Observable<any> {
        return this.HTTP.post('NotificationTemplate/UpdateAppointmentTypeInTemplate', body)
            .map((response) => {
                return response.json().data;
            })
    }


    /**
     * Function to delete the template according to ID
     * @param templateId : TemplateId to be deleted
     */
    deleteTemplateWithId(templateId): Observable<any> {
        return this.HTTP.delete('NotificationTemplate/DeleteTemplate?id=' + templateId)
            .map((response) => {
                return response.json().data
            })
    }

    makeAppointmentTypeTemplateInactive(body): Observable<any> {
        return this.HTTP.post('NotificationTemplate/SetAppointmentTypeInactive', body)
            .map((response) => {
                return response.json().data;
            })
    }

    saveTemplateBody(body): Observable<any> {
        return this.HTTP.post('NotificationTemplate/SaveTemplateBody', body)
            .map((response) => {
                return response.json().data;
            })
    }

    getDashboardData(date, CalendarIds, viewType): Observable<any> {
        return this.HTTP.get('Dashboard/GetDashboardData?CalendarIds=' + CalendarIds + '&CurrentDate=' + date + '&ViewType=' + viewType)
            .map((response) => {
                return response.json().data;
            })
    }

    getDashboardDataList(date, CalendarIds, viewType): Observable<any> {
        return this.HTTP.post('Dashboard/GetDashboardDataList?CurrentDate=' + date + '&ViewType=' + viewType, CalendarIds)
            .map((response) => {
                return response.json().data;
            })
    }

    /**
     * Function to fetch the template body
     * @param templateId : Template Id to fetch data from
     */
    getTemplateBodyWithValueById(templateId, appointmentCode, isPublic: boolean = false): Observable<any> {
        return this.HTTP.get((isPublic ? 'publicflow/' : '') + `NotificationTemplate/GetTemplateBodyWithValueById?notificationTemplateId=${templateId}&AppointmentCode=${appointmentCode}`)
            .map((response) => {
                return response.json().data;
            })
    }


    getTemplateBody(templateId): Observable<any> {
        return this.HTTP.get('NotificationTemplate/GetTemplateBody?notificationTemplateId=' + templateId)
            .map((response) => {
                return response.json().data;
            })
    }

    /**
     * Function to fetch reminder setting in appointment
     */
    getReminderSettings(): Observable<any> {
        return this.HTTP.get('Reminder/GetReminderSettings')
            .map((response) => {
                return response.json().data;
            })
    }

    /**
     * Update reminder settings
     */
    updateReminderSettings(body): Observable<any> {
        return this.HTTP.post('Reminder/SaveReminderSettings', body)
            .map((response) => {
                return response.json().data;
            })
    }

    /**
     * reschedule calendar
     */
    getRescheduleData(AppointmentCode, queryDate, timeZoneId: string, isPublic: boolean = false): Observable<any> {
        var requestOption = new RequestOptions({
            params: {
                AppointmentCode: AppointmentCode,
                PageIndex: -1,
                UserTimeZoneId: timeZoneId,
                queryDate: queryDate,
                FetchLeadUserInfo: false,
                UserType: 1
            }
        })
        return this.HTTP.get((isPublic ? 'publicflow/' : '') + 'Appointment/RescheduleBookedAppointment', requestOption)
            .map((response) => {
                return response.json().data
            })
    }

    /**
   * Function to book appointment
   * @param body : Body
   */
    bookAppointment(body, isPublic: boolean = false): Observable<any> {
        return this.HTTP.post((isPublic ? 'publicflow/' : '') + 'Appointment/ConfirmAppointmentBooking', body)
            .map((response) => {
                return response.json().data;
            })
    }


    /**
     * Function to cancel appointment
     */
    cancelAppointment(body, isPublic: boolean = false): Observable<any> {
        body.OffsetValue = this.OffsetValue
        // body.OffsetValue this.OffsetValue
        return this.HTTP.post((isPublic ? 'publicflow/' : '') + 'Appointment/CancelBookedAppointment', body)
            .map((response) => {
                return response.json().data;
            })

    }

    /**
     * Function to get default template for notification
     */
    getDefaultTemplate(NotificationType): Observable<any> {
        return this.HTTP.get('NotificationTemplate/GetDefaultTemplateByType?NotificationType=' + NotificationType)
            .map((response) => {
                return response.json().data;
            })
    }


    private loading = new Subject<any>();

    loader(data: any) {
        this.loading.next(data);
    }

    isloading() {
        return this.loading.asObservable();
    }

    /**
     * function to get template signature against NotificationType
     */
    // getTemplateSignature(NotificationType){
    //     return this.HTTP.get('NotificationTemplate/GetTemplateSignature?NotificationType='+NotificationType)
    //     .map((response) => {
    //         return response.json().data;
    //     })
    // }
    getTemplateSignature(SignatureType) {
        return this.HTTP.get('NotificationTemplate/GetTemplateSignature?SignatureType=' + SignatureType )
            .map((response) => {
                return response.json().data;
            })
    }
    /**
     * function to save template signature against NotificationType
     */
    saveTemplateSignature(body) {

        return this.HTTP.post('NotificationTemplate/SaveTemplateSignature', body)
            .map((response) => {
                return response.json().data;
            })
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    getTimeZoneList(isPublic: boolean = false): Observable<any> {
        return this.HTTP.get((isPublic ? 'publicflow/' : '') + 'Integration/GetTimeZoneList')
            .map((response) => {
                return response.json().data
            })
    }

    getUrlValueByKey(domain: string, key: string, isPublic: boolean = false): Observable<any> {
        let queryParamsList = `DomainName=${domain}&Key=${key}`;
        return this.HTTP.get((isPublic ? 'publicflow/' : '') + 'Integration/GetUrlValueByKey?' + queryParamsList).map(response => {
            return response.json().data;
        }).catch(err => {

            let data = err.error
            this.sharedService.setErrorMessage(data);
            this.router.navigate(['error']);
            return of(false);

        });
    }

    getAuthorizeEnterpriseConnectUser(emailId: string): Observable<any> {
        return this.HTTP.get(`Integration/AuthorizeEnterpriseConnectUser?Email=${emailId}`)
            .map((response) => {
                return response.json().data;
            }).catch(err => {
                let data = err.error
                this.sharedService.setErrorMessage(data);
                return of(false);
            });
    }

    // Get appointment details by appointment code
    getAppointmentDetailsByCode(AppointmentCode:string, LeadId:string): Observable<any> {
        let url:string = "";
        url = `Dashboard/GetAppointmentDetailsByAppointmentCode?AppointmentCode=${AppointmentCode}&LeadId=${LeadId}`;
        return this.HTTP.get(url).map((response) => {
            return response.json().data;
        }).catch(err => {
            let data = err.error
            this.sharedService.setErrorMessage(data);
            return of(false);
        });
    }

    // Get WhatsApp HSM Templates
    getWhatsAppHSMTemplates(type: string, isPublic: boolean = false): Observable<any> {
        let url = (isPublic ? 'publicflow/' : '') + `WhatsApp/GetHSMTemplates?templatesType=${type}`;
        return this.HTTP.get(url).map((data) => {return data.json()});
    }

    // Get All language List
    getAllLanguageList(isPublic: boolean = false): Observable<any> {
        let url = (isPublic ? 'publicflow/' : '') + `WhatsApp/GetLanguages`;
        return this.HTTP.get(url).map((data) => {return data.json()});
    }
    getMappedSfFieldsList(): Observable<any> {
        let companyCode:string = this.getCookie('clientCode');
        let object: string = "Vacancy,Lead,Contact";
        let Url = `MasterList/${companyCode}/variablefields?objects=${object}`;
        return this.HTTP.get(Url).map((data) => {return data.json()});
      }

    getHSMTemplateDetails(clientCode: string, moduleType: string, languageCode: string, templateId: number): Observable<any> {
        let Url = `WhatsApp/HSMTemplateDetails?clientCode=${clientCode}&moduleType=${moduleType}&languageCode=${languageCode}&templateId=${templateId}`;
        return this.HTTP.get(Url).map((data) => {return data.json()});
    }

    validateCalendarForConference(body) {
        return this.HTTP.post('Appointment/ValidateCalendarForConference', body).map((data) => {return data.json()});
    }

    ValidateAppointmentForConference(body) {
        return this.HTTP.post('Appointment/ValidateAppointmentForConference', body).map((data) => {return data.json()});
    }
}


// WEBPACK FOOTER //
// ./src/app/appointments/appointments.service.ts